// extracted by mini-css-extract-plugin
module.exports = {"container":"c7P1a5fYe20bFzL5gHFxo"};